<template lang="pug">
  div
    v-snackbar(v-model="getTasksBulkLoading" color="success")
      div {{ tasksBulkLoadingMessage }}
    v-snackbar(v-model="getTasksError" color="error")
      div {{ tasksErrorMessage }}
    liondesk-dialog(
      dialogTitle="Too Many Contacts"
      v-model="tooManyContactsError"
      hide-cancel-button
      @click:ok="tooManyContactsError = false"
    )
      v-layout(slot="body" column)
        v-card-text {{ tooManyContactsDialog }}
        v-card-text Please use filters to reduce the number of contacts.
    liondesk-dialog(
      v-model="bulkTextsWarningModal"
      dialogTitle="Too Many Contacts"
      hide-cancel-button
      @click:ok="bulkTextsWarningModal = false"
    )
      v-layout(slot="body" column)
        v-card-text To safeguard your custom number's reputation with carriers, mass texting is not supported in LionDesk. Please select a single contact to text.
    sms-compliance-blocked-dialog(
      :value="showSmsComplianceBlockedDialog"
      @close="showSmsComplianceBlockedDialog = false"
    )
    slide-drawer(v-model="showSlideDrawer" :confirm-dismiss="confirmDismiss")
      template(slot="title")
        span Create New Task
      template(slot="content")
        edit-task(
          ref="taskEditor"
          :contact-ids="selectedIds"
          :all-bulk-contacts="allBulkContacts"
          :is-bulk-task="true"
          :total-contacts-selected="totalContactsSelected"
          @input="confirmDismiss = true"
          @changes-saved="closeSlideDrawer($event)"
          @deselect-all="deSelectAll"
          @contact-updated="refreshPage"
        )
      template(slot="actions")
        v-btn.primary(@click.stop="$refs.taskEditor.saveTasks()") Create Task
    processing-action-modal(
      v-if="bulkActionInProgress"
      :completed="bulkActionsPerformed"
      :total="selectedIds.length"
    )
    start-campaign(
      :start-campaigns="startCampaigns"
      :selected-ids="selectedIds"
      :total-contacts-selected="numberOfContactsSelected"
      @contact-updated="refreshPage"
      @deselect-all="deSelectAll"
      ref="startCampaigns"
    )
    add-event-drawer(
      v-if="!isProfileV2"
      ref="eventDrawer"
      is-bulk
      :isComment="true"
      :process-bulk-action="processBulkAction"
      :selected-ids="selectedIds"
      :validateDescription="validateDescription"
      @contact-updated="refreshPage"
      @deselect-all="deSelectAll"
    )
    v-toolbar(flat color="transparent" v-if="isProfileV2").profile-v2-actions
      bulk-actions-btn(
        :selected-ids-with-assignee-id="selectedIdsWithAssigneeId"
        :selected-contacts="selectedContacts"
        :selected-ids="selectedIds"
        :team-members="assignedUsers"
        :hotnesses="hotnesses"
        :contact-types="contactTypes"
        :bulk-patch-contacts="bulkPatchContacts"
        :email-lists="emailListsByContact"
        :tags="tags"
        :statuses="statuses"
        :sources="sources"
        :validate-description="validateDescription"
        :bulk-create-events="bulkCreateEvents"
        :should-redirect="shouldRedirect"
        @contact-updated="refreshPage"
        @update-email-lists-state="updateEmailListsState"
        @send-bulk-emails="sendBulkEmails"
        @send-bulk-text="sendBulkTexts"
        @openEventDrawer="$emit('openEventDrawer')"
        @call-contact="callContact()"
        @show-task-editor="showTaskEditor"
        @start-Campaign="$refs.startCampaigns.modal_open()"
        @deselect-all="deSelectAll"
        @too-many-contacts-error="throwTooManyContactsError"
        @refresh-page="refreshPage"
        @refresh-events="$emit('refresh-events')"
      )
    v-toolbar(dense flat color="transparent" v-else)
      slot(name="prepend-icons").pa-0
      v-tooltip(bottom)
        ld-gated-button(
          icon
          slot="activator"
          @click="sendBulkEmails"
          :feature="LdFeatures.Emails"
        )
          v-icon email
        span Email
      v-tooltip(bottom)
        v-btn.ld-gated-feature(
          icon
          v-if="gatedAction === gatedActions.ComplianceViolationBlocked"
          slot="activator"
          @click="showSmsComplianceBlockedDialog = true"
        )
          v-icon stay_current_portrait
        template(v-else-if="!userHasTextsAccess")
        v-btn(
          v-else-if="selectedIds.length > 1"
          icon
          slot="activator"
          @click="sendBulkTexts"
        )
          v-icon stay_current_portrait
        ld-gated-button(
          v-else
          icon
          slot="activator"
          @click="sendBulkTexts"
          :feature="LdFeatures.TextMessaging"
        )
          v-icon stay_current_portrait
        span SMS
      v-tooltip(bottom)
        span Add Activities
        v-btn(icon slot="activator" @click="openEventDrawer")
          v-icon event
      v-tooltip(bottom v-if="totalContactsSelected === 1")
        span Call
        v-btn(icon slot="activator" @click="callContact()", data-cy="call-contact")
          v-icon call
      v-tooltip(bottom)
        span Add Tasks
        v-btn(icon slot="activator" @click="showTaskEditor")
          v-icon event_note
      v-tooltip(bottom)
        span Start Campaign
        ld-gated-button(
          v-if="numberOfContactsSelected > 1"
          icon
          slot="activator"
          :feature="LdFeatures.BulkCampaigns"
          @click="handleStartCampaign"
        )
          v-icon flight_takeoff
        ld-gated-button(
          v-else
          icon
          slot="activator"
          :feature="LdFeatures.Campaigns"
          @click="handleStartCampaign"
        )
          v-icon flight_takeoff
      v-menu(offset-y)
        v-btn(icon slot="activator" data-cy="more-bulk-actions-btn")
          v-icon more_vert
        v-list.contact-actions
          edit-hotness(
            :contact-update-action-payload="contactUpdateActionPayload"
            :selected-ids="selectedIds"
            :hotnesses="hotnesses"
            :patch-contacts="processBulkAction"
            :total-contacts-selected="numberOfContactsSelected"
            @deselect-all="deSelectAll"
            @contact-updated="refreshPage"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="")
              v-list-tile-action
                v-icon whatshot
              v-list-tile-content
                span Edit Hotness
          edit-field(
            title="Edit Source"
            :items="sources"
            field-name="source"
            field-text="name"
            field-value="id"
            :contact-update-action-payload="contactUpdateActionPayload"
            :patch-contacts="processBulkAction"
            :selected-ids="selectedIds"
            :total-contacts-selected="numberOfContactsSelected"
            @contact-updated="refreshPage"
            @deselect-all="deSelectAll"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="")
              v-list-tile-action
                v-icon play_for_work
              v-list-tile-content
                span Edit Source
          edit-field(
            title="Edit Status"
            :items="statuses"
            field-name="status"
            field-text="name"
            field-value="id"
            :contact-update-action-payload="contactUpdateActionPayload"
            :patch-contacts="processBulkAction"
            :selected-ids="selectedIds"
            :total-contacts-selected="numberOfContactsSelected"
            @contact-updated="refreshPage"
            @deselect-all="deSelectAll"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="")
              v-list-tile-action
                v-icon create
              v-list-tile-content
                span Edit Status
          edit-contact-type(
            :contact-update-action-payload="contactUpdateActionPayload"
            :selected-ids="selectedIds"
            :contact-types="contactTypes"
            :patch-contacts="processBulkAction"
            :total-contacts-selected="numberOfContactsSelected"
            @deselect-all="deSelectAll"
            @contact-updated="refreshPage"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="")
              v-list-tile-action
                v-icon subject
              v-list-tile-content
                span Edit Contact Type
          edit-assigned-user(
            :contact-update-action-payload="contactUpdateActionPayload"
            :selected-ids="selectedIds"
            :selected-ids-with-assignee-id="selectedIdsWithAssigneeId"
            :team-members="assignedUsers"
            :patch-contacts="processBulkAction"
            :total-contacts-selected="numberOfContactsSelected"
            @deselect-all="deSelectAll"
            @contact-updated="refreshPage"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="")
              v-list-tile-action
                v-icon supervisor_account
              v-list-tile-content
                span Edit Assigned User
          tags(
            action="add"
            :tags-list="tags"
            :selected-ids="selectedIds"
            :patch-contacts="processBulkAction"
            :contact-update-action-payload="contactUpdateActionPayload"
            :total-contacts-selected="numberOfContactsSelected"
            @deselect-all="deSelectAll"
            @contact-updated="refreshPage"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="" data-cy="add-tags")
              v-list-tile-action
                v-icon local_offer
              v-list-tile-content
                span Add Tags
          tags(
            action="remove"
            :tags-list="tags"
            :selected-ids="selectedIds"
            :patch-contacts="processBulkAction"
            :contact-update-action-payload="contactUpdateActionPayload"
            :total-contacts-selected="numberOfContactsSelected"
            @deselect-all="deSelectAll"
            @contact-updated="refreshPage"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="" data-cy="remove-tags")
              v-list-tile-action
                v-icon $vuetify.icons.tag-minus
              v-list-tile-content
                span Remove Tags
          tags(
            action="replace"
            :tags-list="tags"
            :selected-ids="selectedIds"
            :patch-contacts="processBulkAction"
            :contact-update-action-payload="contactUpdateActionPayload"
            :total-contacts-selected="numberOfContactsSelected"
            @deselect-all="deSelectAll"
            @contact-updated="refreshPage"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="" data-cy="replace-tags")
              v-list-tile-action
                v-icon $vuetify.icons.tag-right-arrow
              v-list-tile-content
                span Replace Tags
          tags(
            action="delete"
            :tags-list="tags"
            :selected-ids="selectedIds"
            :patch-contacts="processBulkAction"
            :contact-update-action-payload="contactUpdateActionPayload"
            :total-contacts-selected="numberOfContactsSelected"
            @deselect-all="deSelectAll"
            @contact-updated="refreshPage"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="" data-cy="delete-tags")
              v-list-tile-action
                v-icon $vuetify.icons.tag-remove
              v-list-tile-content
                span Delete Tags
          AddContactsToStaticList(
            :selected-ids="selectedIds"
            :patch-contacts="bulkPatchContacts"
            :fetch-all-contacts="handleFetchAllContacts"
            @deselect-all="deSelectAll"
            @contact-updated="refreshPage"
          )
            //- @click="" is necessary to show blue hover highlight
            v-list-tile(slot="activator" @click="")
              v-list-tile-action
                v-icon person_add
              v-list-tile-content
                span Add to Static List
          delete-contact-from-static-lists.contact-card-settings(
            :emailLists="emailListsByContact"
            v-if="emailListsByContact.length > 0"
            v-on:updateEmailListsState="updateEmailListsState"
          )
              v-list-tile(
                slot="activator"
                @click=""
              )
                v-list-tile-action
                  v-icon person_add_disabled
                v-list-tile-content
                  span Remove From Static List
          delete-contact(
            :selected-ids="selectedIds"
            :selected-contacts="selectedContacts"
            :should-redirect="shouldRedirect"
            :bulk-delete-contacts="processBulkAction"
            :total-contacts-selected="numberOfContactsSelected"
            @deselect-all="deSelectAll"
            @contact-deleted="refreshPage"
          )
            v-list-tile(slot="activator" @click="")
              v-list-tile-action
                v-icon delete
              v-list-tile-content
                span Delete {{ contactsAmount }}
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import toggleSlideDrawer from '@/Core/mixins/toggle-slide-drawer';
import SlideDrawer from '@/Core/components/SlideDrawer';
import EditTask from '@/Tasks/components/EditTask';
import AddTag from '@/Contacts/components/actions/AddTagModal';
import Tags from '@/Contacts/components/actions/TagModal';
import DeleteContact from '@/Contacts/components/actions/DeleteContact';
import AddEvent from '@/Contacts/components/actions/AddEventModal';
import EditField from '@/Contacts/components/actions/EditFieldModal';
import EditHotness from '@/Contacts/components/actions/EditHotness';
import StartCampaign from '@/Contacts/components/actions/StartCampaignModal';
import EditContactType from '@/Contacts/components/actions/EditContactType';
import EditAssignedUser from '@/Contacts/components/actions/EditAssignedUser';
import AddContactsToStaticList from '@/Contacts/components/actions/AddContactsToStaticList';
import ProcessingActionModal from '@/Contacts/components/actions/ProcessingActionModal';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import MaxContacts from '@/Contacts/config/bulk-action-limits';
import DeleteContactFromStaticLists from '@/Contacts/components/actions/DeleteContactFromStaticLists';
import { LdGatedButton, LdFeatures } from 'lion-vue';
import { formatInternationalPhoneNumber } from '@/Core/utilities/formatInternationalPhoneNumber';
import { MAX_DESCRIPTION_LENGTH } from '@/Core/config/events';
import BulkActionsBtn from '@/Contacts/components/profile-v2/BulkActionv2';
import { HIDE_ERROR_AFTER_MS, DEFAULT_UNSET_OPTION } from '@/Core/utilities';
import {
  ES_STATUS
} from '@/Contacts/config/profile-optin-status'
import sendSMSGate from '@/Core/mixins/send-sms-gate';

const RegisterBrandModal = () =>
    import(/* webpackChunkName: 'RegisterBrandModal' */ '@/Core/components/RegisterBrandModal');
const AddEventDrawer = () =>
  import(/* webpackChunkName: 'AddEventDrawer' */ '@/Contacts/components/actions/AddEventDrawer');

export default {
  components: {
    AddTag,
    Tags,
    DeleteContact,
    EditTask,
    EditField,
    EditHotness,
    AddEvent,
    EditContactType,
    EditAssignedUser,
    StartCampaign,
    SlideDrawer,
    LiondeskDialog,
    ProcessingActionModal,
    LdGatedButton,
    AddContactsToStaticList,
    DeleteContactFromStaticLists,
    BulkActionsBtn,
    RegisterBrandModal,
    AddEventDrawer,
    SmsComplianceBlockedDialog: () =>
      import(/* webpackChunkName: 'SmsComplianceBlockedDialog' */ '@/Core/components/SmsComplianceBlockedDialog'),
  },
  props: {
    selectedIdsWithAssigneeId: {
      type: Array,
      default: () => [],
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
    selectedContacts: {
      type: Array,
      default: () => [],
    },
    query: Object,
    shouldRedirect: {
      type: Boolean,
      default: false,
    },
    isProfileV2: {
      type: Boolean,
      default: false,
    },
    fetchAllContacts: {
      type: Function,
    },
    fetchAllRecipients: {
      type: Function,
    },
    numberOfContactsSelected: {
      type: Number,
    },
    allContactsSelected: {
      type: Boolean,
    },
  },
  async created() {
    this.loadContactSources();
    this.loadContactTypes();
    this.findStatuses();
    this.loadContactHotnesses();
    this.findTeamMembersIfEmpty();
    if (!this.has10dlcRegister || this.isRegistration10dlcIncomplete) {
      await this.checkFor10dlcRegister();
    }
  },
  beforeDestroy() {
    // allow all current alerts to complete before clearing
    setTimeout(() => {
      this.clearAlerts();
    }, HIDE_ERROR_AFTER_MS);
    this.resetTaskLoadingState();
  },
  mixins: [toggleSlideDrawer, sendSMSGate],
  data() {
    return {
      LdFeatures,
      tooManyContactsError: false,
      bulkTextsWarningModal: false,
      tooManyContactsErrorType: null,
      processing: false,
      showRegisterBrandModal: false,
      showSmsComplianceBlockedDialog: false,
    };
  },
  computed: {
    ...mapGetters('teamMembers', ['teamMembersInfo']),
    ...mapGetters('userInformation', ['userHasFeatureFlag', 'hasAccessToFeature']),
    ...mapGetters({
      hotnesses: 'contact/hotnessesWithRemoveOption',
      sources: 'contact/sourcesWithRemoveItem',
      contactTypes: 'contact/contactTypesWithRemoveItem',
    }),
    ...mapState({
      contact: state => state.contact.contact,
      contacts: state => state.contactsTable.contacts,
      allBulkContacts: state => state.contactsTable.allBulkContacts,
      tags: state => state.contact.tags,
      statuses: state => state.contactsStatus.statuses,
      bulkActionInProgress: state => state.contactsTable.bulkActions.inProgress,
      bulkActionsPerformed: state => state.contactsTable.bulkActions.actionsPerformed,
      userInformation: state => state.userInformation,
      emailListsByContact: state => state.contact.emailListsByContact,
      tasksBulkLoading: state => state.tasks.tasksBulkLoading,
      tasksBulkLoadingMessage: state => state.tasks.tasksBulkLoadingMessage,
      tasksError: state => state.tasks.tasksError,
      tasksErrorMessage: state => state.tasks.tasksErrorMessage,
      bulkTaskInProgress: state => state.tasks.inProgress,
      user: state => state.userInformation.user,
      has10dlcRegister: state => state.conversations.has10dlcRegister,
      isRegistration10dlcIncomplete: state => state.conversations.isRegistration10dlcIncomplete,
    }),
    assignedUsers() {
      return [DEFAULT_UNSET_OPTION, ...this.teamMembersInfo];
    },
    contactsAmount() {
      return this.selectedIds.length > 1 ? 'Contacts' : 'Contact';
    },
    tooManyContactsDialog() {
      return `You can only apply this action for up to ${
        MaxContacts[this.tooManyContactsErrorType]
      } contacts at a time.`;
    },
    async callPayload() {
      const contact = await this.findContact(this.selectedIds[0]);
      return {
        contactId: this.selectedIds[0],
        phone: contact.mobile_phone,
        agentName:
          `${this.userInformation.user.first_name || ''} ` +
          `${this.userInformation.user.last_name || ''}`,
        type: 'Mobile phone',
      };
    },
    getTasksBulkLoading: {
      get() {
        return this.tasksBulkLoading;
      },
      set(value) {
        this.resetTaskLoadingState();
      }
    },
    getTasksError: {
      get() {
        return this.tasksError;
      },
      set(value) {
        this.resetTaskLoadingState();
      }
    },
    totalContactsSelected() {
      return this.isProfileV2 ? this.selectedIds.length : this.numberOfContactsSelected;
    },
    userHasBulkCommsFF() {
      return this.userHasFeatureFlag('comms-bulk-actions');
    },
    userHasBulkTextsAccess() {
      return this.hasAccessToFeature(LdFeatures.BulkTexts);
    },
    userHasTextsAccess() {
      return this.hasAccessToFeature(LdFeatures.TextMessaging);
    },
  },
  watch: {
    showSlideDrawer(value) {
      this.setIsEditTaskOpen(value);
    },
    bulkActionInProgress(val) {
      if(!val) return;
      this.openBulkInProgressModal();
    },
    bulkTaskInProgress(val) {
      if(!val) return;
      const payloadAction = { resource: 'tasks' };
      this.setBulkActionType(payloadAction);
      this.openBulkInProgressModal();
    },
  },
  methods: {
    ...mapActions('contact', [
      'loadContactHotnesses',
      'loadContactSources',
      'loadContactTypes'
    ]),
    ...mapActions('contactsStatus', ['findStatuses']),
    ...mapActions('contactsTable', ['findContacts', 'findContact', 'findSelectedContacts']),
    ...mapActions('contactsTable/bulkActions', [
      'bulkPatchContacts',
      'bulkCreateEvents',
      'bulkStartCampaigns',
      'clearAlerts',
      'processBulkAction',
      'setBulkActionType',
    ]),
    ...mapActions('tasks', [
      'getTask',
      'setAllContactsSelected',
      'resetTaskLoadingState',
    ]),
    ...mapActions('contact', ['patchContact', 'makeCall', 'findEmailListsByContact']),
    ...mapActions({
      setToSelected: 'recipients/setToSelected',
    }),
    ...mapActions('contactsSearchCampaign', ['findCampaigns']),
    ...mapActions('teamMembers', ['findTeamMembersIfEmpty']),
    ...mapActions('conversations', ['checkFor10dlcRegister']),
    ...mapMutations('tasks', ['setIsEditTaskOpen']),
    async showTaskEditor() {
      const $limit = MaxContacts.tasks;

      await this.getTask(null);
      if (this.selectedIds.length === this.allBulkContacts.length) {
        this.setAllContactsSelected(this.allBulkContacts);
      } else {
        const queryParams = { id: { $in: this.selectedIds }, $limit };
        const contacts = await this.findSelectedContacts(queryParams);
        const selectedContactsFilter = contacts.filter(contact => {
          return this.selectedIds.includes(contact.id);
        });
        this.setAllContactsSelected(selectedContactsFilter);
      }
      this.confirmDismiss = false;
      this.openSlideDrawer();
    },
    refreshPage() {
      this.$emit('contact-updated');
    },
    openBulkInProgressModal() {
      this.$emit('bulk-tasks-in-progress');
    },
    deSelectAll() {
      this.$emit('deselect-all');
    },
    /**
     * Formats the selected contacts to be the expected format for the selected recipients
     * Sets the selected email recipients to be this formatted selected contacts`
     */
    async sendBulkEmails() {
      const $limit = MaxContacts.emails;
      if (this.totalContactsSelected > $limit) {
        return this.throwTooManyContactsError("emails");
      }

      let selectedContactsFilter;
      if (this.userHasBulkCommsFF) {
        if (!this.isProfileV2 && this.allContactsSelected) {
          await this.fetchAllRecipients('email');
          selectedContactsFilter = this.allBulkContacts;
        }

        if (!this.allContactsSelected) {
          const queryParams = { id: { $in: this.selectedIds } };
          const contacts = await this.findSelectedContacts(queryParams);
          selectedContactsFilter = contacts.filter(contact => contact.id && (contact.email_primary || contact.email))
        }
      } else {
        if (!this.isProfileV2) {
          await this.fetchAllContacts();
        }

        const queryParams = { id: { $in: this.selectedIds }, $limit };
        const contacts = await this.findSelectedContacts(queryParams);
        selectedContactsFilter = contacts.filter(contact => {
          return this.selectedIds.includes(contact.id);
        });
      }

      const userTimezone = this.userInformation.user.timezone;
      const parsedContacts = selectedContactsFilter.map(contact => {
        let status = ES_STATUS.pending;
        if (contact.opted_out_users && contact.opted_out_users.includes(this.userInformation.user.id)) {
          status = ES_STATUS.denied;
        } else if (contact.opted_in_users && contact.opted_in_users.includes(this.userInformation.user.id)) {
          status = ES_STATUS.approved;
        }
        return {
          id: contact.id,
          email: contact.email_primary || contact.email,
          first_name: contact.first_name,
          last_name: contact.last_name,
          opt_in_status: status,
          mobile_phone: formatInternationalPhoneNumber(
            contact.mobile_phone || contact.phone_mobile,
            userTimezone,
          ),
        };
      });

      if (this.userHasBulkCommsFF) {
        this.setToSelected(parsedContacts);
      } else {
        this.setToSelected(parsedContacts.filter(contact => contact.id && contact.email));
      }
      this.$emit('openEmailDrawer');
    },
    /**
     * Formats the selected contacts to be the expected format for the selected recipients
     * Sets the selected email recipients to be this formatted selected contacts`
     */
    async sendBulkTexts() {
      if (this.selectedIds.length > 1 && !this.userHasBulkTextsAccess) {
        this.bulkTextsWarningModal = true;
        return;
      }

      const type = this.userHasFeatureFlag('bulk_sms') ? "textsV2" : "texts";
      const $limit = MaxContacts[type];
      if (this.totalContactsSelected > $limit) {
        return this.throwTooManyContactsError(type);
      }

      let selectedContactsFilter;
      if (this.userHasBulkCommsFF) {
        if (!this.isProfileV2 && this.allContactsSelected) {
          await this.fetchAllRecipients('sms');
          selectedContactsFilter = this.allBulkContacts;
        }

        if (!this.allContactsSelected) {
          const queryParams = { id: { $in: this.selectedIds } };
          const contacts = await this.findSelectedContacts(queryParams);
          selectedContactsFilter = contacts.filter(contact => contact.id && (contact.mobile_phone || contact.phone_mobile));
        }
      } else {
        if (!this.isProfileV2) {
          await this.fetchAllContacts();
        }

        const queryParams = { id: { $in: this.selectedIds }, $limit };
        selectedContactsFilter = await this.findSelectedContacts(queryParams);
      }

      const userTimezone = this.userInformation.user.timezone;
      // TODO: Fix this in the backend... may be preferable normalize the models
      // properties in order to match the database to avoid this kind of issues.
      const parsedContacts = selectedContactsFilter.map(contact => {
        let status = ES_STATUS.pending;
        if (contact.opted_out_users && contact.opted_out_users.includes(this.userInformation.user.id)) {
          status = ES_STATUS.denied;
        } else if (contact.opted_in_users && contact.opted_in_users.includes(this.userInformation.user.id)) {
          status = ES_STATUS.approved;
        }
        return {
          id: contact.id,
          mobile_phone: formatInternationalPhoneNumber(
            contact.mobile_phone || contact.phone_mobile,
            userTimezone,
          ),
          first_name: contact.first_name,
          last_name: contact.last_name,
          opt_in_status: status,
          email: contact.email_primary || contact.email,
        };
      });

      if (this.userHasBulkCommsFF) {
        this.setToSelected(parsedContacts);
      } else {
        this.setToSelected(parsedContacts.filter(contact => contact.id && contact.mobile_phone));
      }
      selectedContactsFilter.length === 1
        ? this.$emit('showChatDrawer', selectedContactsFilter[0].id)
        : this.$router.push('/communications/text/bulk');
    },
    async startCampaigns(campaigns) {
      return await this.processBulkAction(campaigns);
    },
    throwTooManyContactsError(type) {
      this.tooManyContactsError = true;
      this.tooManyContactsErrorType = type;
    },
    async callContact() {
      const payload = await this.callPayload;
      this.makeCall(payload);
    },
    async updateEmailListsState() {
      await this.findEmailListsByContact(this.contact.id);
    },
    validateDescription(description) {
      if (description.length > MAX_DESCRIPTION_LENGTH) {
        this.showEventsError(`Description should be shorter than ${MAX_DESCRIPTION_LENGTH} characters.`)
        return false;
      }
      return true;
    },
    async handleStartCampaign() {
      if (this.selectedIds && this.selectedIds.length > MaxContacts.campaigns) {
        return this.throwTooManyContactsError("campaigns");
      }
      await this.findCampaigns();
      this.$refs.startCampaigns.modal_open()
    },
    contactUpdateActionPayload(payload) {
      return {
        type: "update",
        resource: "contacts",
        payload,
      };
    },
    async handleFetchAllContacts() {
      if (this.isProfileV2) return;
      await this.fetchAllContacts();
    },
    openEventDrawer() {
      this.$refs.eventDrawer.openSlideDrawer();
      this.$refs.eventDrawer.resetDragPosition();
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-v2-actions > .v-toolbar__content {
  height: 100% !important;
  padding: 10px 0;
}
@media screen and (width: 2560px) {
  .profile-v2-actions > .v-toolbar__content {
    position: relative;
    right: 2%;
  }
}
@media screen and (max-width: 1920px) {
  .profile-v2-actions > .v-toolbar__content {
    position: relative;
    right: 3%;
  }
}
@media screen and (max-width: 1440px) {
  .profile-v2-actions > .v-toolbar__content {
    position: relative;
    right: 2%;
  }

  .profile-v2-actions {
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 1152px) {
  .profile-v2-actions {
    margin-bottom: 60px;
  }
}

@media screen and (max-width: 990px) {
  .profile-v2-actions {
    margin-bottom: 110px;
  }
}

@media screen and (max-width: 766px) {
  .profile-v2-actions {
    margin-bottom: 170px;
  }
}

@media screen and (max-width: 608px) {
  .profile-v2-actions {
    margin-bottom: 300px;
  }
}
</style>
